import styles from './index.module.less';
import FJAccountListContainer from '@src/components/FJModals/FJShareModal/FJAccount/FJAccountListContainer.tsx';
import FJModalClose from '@src/components/FJModals/FJModalClose/FJModalClose.tsx';
import FJAddAccountPanelContainer from '@src/components/FJModals/FJShareModal/FJAddAccount/FJAddAccountPanelContainer.tsx';
import FJPublishSetting from '@src/components/FJModals/FJShareModal/FJShareContent/FJPublishSetting.tsx';

const FJShareView = ({ onClose, isHideClose }: { onClose: () => void; isHideClose: boolean }) => {
    return (
        <div className={styles.main_box}>
            {!isHideClose && <FJModalClose onClick={onClose} />}
            <div className={styles.content}>
                <FJAccountListContainer />
                <FJPublishSetting />
            </div>
            <FJAddAccountPanelContainer />
        </div>
    );
};

export default FJShareView;
